import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Forgotpassword from './forgotpassword';
import ResetPassword from './resetpassword';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';


export default function Sigin() {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    const [login, setLogin] = useState(true);
    const [forgotpassword, setForgotpassword] = useState(false);
    const [resetpassword, setResetpassword] = useState(false);

    const navigate = useNavigate()

    const ForgotPassword1 = () => {
        setLogin(false);
        setForgotpassword(true);
    };

    const ResetPassword1 = () => {
        setLogin(false);
        setForgotpassword(false);
        setResetpassword(true);
    };

    const closePopup = () => {
        setResetpassword(false);
        setLogin(false);
        setForgotpassword(false);
        document.body.classList.remove('popup-open');
    };

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        const lowerCaseValue = name === 'email' ? value.toLowerCase() : value;
        setFormData({ ...formData, [name]: lowerCaseValue });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setError(""); 
            const { email, password } = formData;
            const response = await axios.post(
                `${baseUrl}/admin/login`,
                {
                    email,
                    password,
                }
            );

            if (response.data.isSuccess) {
                localStorage.setItem("tokenfirst", response.data.result.token);
                console.log("Token saved to localStorage:", response.data.result.token);

                const token = localStorage.getItem("tokenfirst");
                console.log("Retrieved token from localStorage:", token);


        const decodedToken = jwtDecode(token);
                const userRole = decodedToken.userRole;
                console.log("Retrieved token from localStorage:", userRole);


                if (userRole === 1) {
                    window.location = "/vendor";            
                } else if (userRole === 0) {
                window.location = "/admin";            
            } else {
                    setError("You do not have access to the Admin panel.");
                }
                // navigate("/admin")
                // window.location = "/admin";            




            }

            else {
                setError(response.data.message);
            }
        } catch (err) {
            if (err.response && err.response.status >= 400 && err.response.status <= 500) {
                setError(err.response.data.message); // Display error from server response
            } else {
                setError("Internal Server Error");
            }
        }
    };


    return (
        <>
            <div className="grid place-content-center w-full h-screen">
                <div className="text-center lg:w-[600px] md:w-[400px] w-[280px]">
                    <p className="mb-10 text-[24px] font-[700] text-[#121212] vol cursor-pointer">
                        We Help You First                    </p>
                    {login && (
                        <form onSubmit={handleSubmit}>
                            <div className="">
                                <p className="text-[#121212] text-[24px] pb-4">Login in to your Account</p>

                                <input type="text" name="email" value={formData.email} onChange={handleChange} className='border-[#CFD3D4] border-[1px] lg:w-[590px] md:w-[380px] w-[280px] h-[50px] rounded-[8px] text-[#ABAFB1] md:text-[16px] text-[14px] lg:pl-5 pl-2 mb-5' placeholder='Enter your email address / Username' />

                                <input type="text" name="password" value={formData.password} onChange={handleChange} className='border-[#CFD3D4] border-[1px] lg:w-[590px] md:w-[380px] w-[280px] h-[50px] rounded-[8px] text-[#ABAFB1] md:text-[16px] text-[14px] lg:pl-5 pl-2 ' placeholder='Enter your password' />

                                <p onClick={ForgotPassword1} className="cursor-pointer text-[#2A668D]text-[12px] font-[400] underline underline-offset-2 text-right mt-3">
                                    Forget Password?
                                </p>
                                <button className='w-[175px] mt-5 h-[40px] bg-[#2A668D] text-white rounded-[4px]'>
                                    Sign In
                                </button>
                            </div>
                        </form>
                    )}
                    {error && <p className="error-message text-red-500 justify-center">{error}</p>}
                    {forgotpassword && (
                        <div className="">
                            {/* <p className="text-[#121212] text-[24px] pb-4">Enter email to recover your password</p>
                            <input type="text" className='border-[#CFD3D4] border-[1px] lg:w-[590px] md:w-[380px] w-[280px] h-[50px] rounded-[8px] text-[#ABAFB1] md:text-[16px] text-[14px] lg:pl-5 pl-2 mb-5' placeholder='Enter your email address / Username' />
                            <button onClick={ResetPassword} className='w-[175px] mt-5 h-[40px] bg-[#008081] text-white rounded-[4px]'>
                                Reset Password
                            </button> */}
                            <Forgotpassword />
                        </div>
                    )}

                    {resetpassword && (
                        <div className="">
                            {/* <p className="text-[#121212] text-[24px] pb-4">Reset your password</p>

                            <input type="text" className='border-[#CFD3D4] border-[1px] lg:w-[590px] md:w-[380px] w-[280px] h-[50px] rounded-[8px] text-[#ABAFB1] md:text-[16px] text-[14px] lg:pl-5 pl-2 mb-5' placeholder='Enter your new password' />
                            <input type="text" className='border-[#CFD3D4] border-[1px] lg:w-[590px] md:w-[380px] w-[280px] h-[50px] rounded-[8px] text-[#ABAFB1] md:text-[16px] text-[14px] lg:pl-5 pl-2 mb-5' placeholder='Confirm password' />
                            <button onClick={ResetPassword} className='w-[175px] mt-5 h-[40px] bg-[#008081] text-white rounded-[4px]'>
                                Update Password
                            </button> */}

                            <ResetPassword />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
